import React, { FC, useEffect, useMemo, useState } from 'react'
import ReactQuill from 'react-quill'

import { toolbarModules } from 'shared/quill/editorOptions'
import { setInitialData } from 'modules/Labels/utils'

import { QuillFormProps } from './QuillForm.props'

import 'react-quill/dist/quill.snow.css'

const QuillForm: FC<QuillFormProps> = ({
  initialData,
  isDisabled,
  onChange,
  classList,
  hideLabel,
  withReset = false,
  isProject = false,
  isMessages = false,
  label,
  field,
  dataTest
}) => {
  const initialValue = useMemo(
    () => (isMessages ? initialData || '' : setInitialData(isProject, initialData)),
    [initialData, isProject, isMessages]
  )
  const [value, setValue] = useState(initialValue)

  useEffect(() => {
    if (onChange && (!initialData || value !== initialValue)) {
      onChange(isProject ? JSON.stringify({ notes: value }) : value)
    }
  }, [field, initialData, initialValue, isProject, onChange, value])

  useEffect(() => {
    if (initialData) {
      onChange && onChange(initialValue)
      setValue(initialValue)
    }
  }, [initialData, initialValue, onChange])

  return (
    <div className={`${classList}`}>
      <form className="quill-form form-abstract form-group">
        {!hideLabel && <label>{label}</label>}
        <div className="quill-form-editor form-control" data-test={dataTest}>
          <ReactQuill
            theme="snow"
            value={value}
            onChange={setValue}
            modules={toolbarModules.minimal}
            readOnly={isDisabled}
          />
          {withReset && (
            <button type="button" className="quill-form__reset" onClick={() => setValue('')}>
              <i className="fas fa-trash" />
            </button>
          )}
        </div>
      </form>
    </div>
  )
}

export default QuillForm
